<template>
  <div id="success">
    <div class="success"></div>
    <h5>对不起，您的审核未通过！</h5>
    <span>
      您申请成为本协会
      <apply-name/>未通过
    </span>
    <span>
      退回原因：
      <em>{{rejectReason}}</em>
    </span>

    <div class="btn-fair btn-home">
      <router-link :to="{path:'/member/apply',query: {type:'r'}}">重新申请</router-link>
    </div>
  </div>
</template>

<script>
import ApplyName from '@/components/member/ApplyName.vue'
export default {
  components: {
    ApplyName
  },
  data() {
    return {
      rejectReason: ''
    }
  },
  created() {
    this.getRejectReason()
  },
  methods: {
    getRejectReason() {
      this.$fetch('/api/OrganizationEnterprise/GetOrganizationRejectReason').then(result => {
        this.rejectReason = result
      })
    }
  }
}
</script>

<style lang="less" scoped>
#success {
  height: 100%;
  background: #fff;
}

.success {
  width: 100%;
  height: 437 / @rem-size;
  background: url('../../assets/images/fair.png');
  background-size: 100% 100%;
}

h5 {
  font-size: 36 / @rem-size;
  color: #333;
  margin-top: 24 / @rem-size;
  font-weight: normal;
  text-align: center;
}

span {
  display: block;
  font-size: 28 / @rem-size;
  text-align: center;
  margin-top: 24 / @rem-size;
  color: #999;

  em {
    color: #333;
    font-style: normal;
  }
}

.btn-home {
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  text-align: center;
  line-height: 80 / @rem-size;
  font-size: 36 / @rem-size;
  margin: 0 auto;
  margin-top: 120 / @rem-size;
  border-radius: 8 / @rem-size;

  a {
    color: #fff;
  }
}
</style>
